export default {
  appName: "GISagro 4.0",
  appTitle: "GISagro Land",
  appSubTitle: "GIS for Agriculture",

  en: "English",
  a: "a",
  an: "an",

  about: "About",
  aboutUs: "About Us",
  above: "Above",
  accept: "Accept",
  account: "Account",
  accountId: "Account ID",
  address: "Address",
  addressNo: "Address No",
  addressMoo: "Moo",
  addressVill: "Vill Name",
  addressFloor: "Floor",
  addressBuilding: "Building Name",
  alreadyRegistered: "Already Registered",
  atLeast4Letters: "4-12 letters and/or digits",
  atLeast6Letters: "6 or more letters/digits",

  systemAdmin: "System Admin",
  admin: "Admin",
  administrator: "Administrator",
  adminOfficialAccount: "Official Accounts",
  adminServiceCatalog: "Manage Catalogs",
  adminTeam: "Admin Team",
  adminUser: "Admin User",
  adminOrganization: "Admin Organization",
  adminUserLog: "User Logs",
  adminNews: "Publish News",

  add: "Add",
  addTo: "Add", 
  addToGISagro: "Add to Farmland Layer",
  again: "Again",
  againZH: "",
  ago: "ago",
  agree: "Agree",
  agreeWith: "Agree With",
  album: "Album",
  all: "All",
  alley: "Alley",
  allSelected: "All Selected",
  and: "and",
  andOr: "and/or",
  aor: "AoR",
  area: "Area",
  area2: "Area",
  askFor: "Ask for",
  assignee: "Assignee",
  assignment: "Assignment",
  asWellAs: "And",
  attention: "Attention",
  atTime: "at",
  avatar: "Avatar",
  back: "Back",
  background: "Background",
  baseLayers: "Base Layers",
  birthday: "Birthday",
  block: "Block",
  blockedList: "Blocked List",
  bounded: "Bounded",
  brand: "Brand",
  browse: "Read",
  calculateData: "Calculate Data",
  camera: "Camera",
  cancel: "CANCEL",
  captcha: "CAPTCHA",
  catchword: "Catchword",
  category: "Category",
  category2: "Category",
  change: "Change",
  channelTypeDirect: "Direct",
  channelTypePrivate: "Group",
  channelTypePublic: "Public",

  chat: "Chat",
  chats: "Chat",
  chatUs: "Chat Us",
  chinese: "Chinese",
  click: "Click",
  clickAt: "Click at",
  clickToReadDetails: "Click to read details",
  clickToSelectPhoto: "Click photo to select at least one",
  close: "CLOSE",
  closeJob: "Close Job",
  code: "Code",
  comma: ",",
  comment: "Comments",
  conclusion: "Conclusion",
  conditions: "Conditions",
  confirm: "Confirm",
  confirmationCode: "Confirmation Code",
  contacts: "Contacts",
  contactUs: "Contact Us",
  contactTypeBlocked: "Blocked",
  contactTypeGroup: "Friend Groups",
  contactTypeIndividual: "Friends",
  contactTypeInvited: "New Friends",
  contactTypeOfficial: "Official Services",
  coordinate: "Coordinate",
  correction: "Correction",
  copyrightHallo: "2017",
  country: "Country",
  county: "District",
  countyName: "District Name",
  cubicMeterPerRai: "cu.m/rai",
  create: "Create",

  crop: "Crop",
  cropRice: "Rice",
  cropMaize: "Maize",
  cropSugarcane: "Sugarcane",
  cropCassava: "Cassava",

  cassava: "Cassava",
  coconut: "Coconut",
  coffee: "Coffee",
  durian: "Durian",
  garden: "Mixed Garden",
  longan: "Longan",
  maize: "Maize",
  mangosteen: "Mangosteen",
  palm: "Palm",
  pineapple: "Pineapple",
  rambuton: "Rambuton",
  rice: "Rice",
  rubber: "Rubber",
  sugarcane: "Sugarcane",
  

  daily: "Daily",
  dashboard: "Dashboard",
  data: "Data",
  dateRange: "Date Range",
  dateTime: "Date and Time",
  dates: "Dates",
  day: "Day",
  days: "Day%s",
  description: "Description",
  details: "Details",
  delete: "Delete",
  diseaseAndPest: "Disease & Pest",
  diseasesAndPests: "Diseases & Pests in %s",
  displayName: "Full Name / Nickname",
  distance: "Distance",
  done: "DONE",
  dol: "DOL",
  doubleQuote: "\"",
  download: "Download",
  downloadAsShapeFile: "File *.shp",
  downloadAsExcelFile: "File *.xlsx",
  downloadPlantData: "%s Data",
  downloadShapeFile: "Shape File (*.zip)",
  downloadMapFile: "Map by Province (.pdf)",
  downloadReportFile: "Report by Province (*.xlsx)",
  downloadRIDFile: "Report by RID Area (*.xlsx)",
  downloadPlantDisaster: "Weekly Disaster Report (*.zip)",
  dragAndDropFileHere: "Drag & Drop File (%s) Here",
  dropFileHere: "Drop File Here",
  edit: "Edit",
  email: "Email",
  emailAddress: 'Email Address',
  endDate: "End Date",
  english: "English",
  enlarge: "Enlarge",
  enter: "Enter",
  error: "Error",
  extraInfo: "Extra Info",
  failed: "Failed",
  farmland: "Farmland",
  farmlandShape: "Farmland Map (*.shp)",
  featureInfo: "Feature Info",
  feedback: "Feedback",
  female: "Female",
  file: "File",
  files: "Files",
  fileHasNoData: "The file doesn't contain any data",
  fileSize: "Size",
  filterData: "Filter Data",
  filterMap: "Filter Map",
  followingSettings: "Following Settings",
  formula: "Formula",
  from: "From",
  fromZH: "",
  fullName: "Full Name",
  faq: "FAQ",
  forgot: "Forgot",
  friend: "Friends",

  gap: "GAP",
  organicFood: "Organic Food",
  rspo: "RSPO",

  gender: "Gender",
  general: "General",
  givenName: "Given Name",
  giveYourComment: "Give Your Comment",
  grant: "Grant",
  group: "Group",
  growingAreaEvery2Weeks: "%s Growing Area from Satellite",
  growingAreaIn: "%s Growing Data",

  administrators: "Super Admin",
  applicationSupports: "Administrator",
  executives: "Executive",
  governors: "Governor",
  managers: "Manager",
  directors: "Director",
  divisionManagers: "Division Manager",
  sectionChiefs: "Section Chief",
  teamLeads: "Team Lead",
  teamMembers: "Team Member",
  operators: "Farmer Servant",
  operatorsOthers: "Operator",
  citizens: "Farmer",
  businessMen: "Business Man",
  Specialists: "Specialist",

  halfYear: "Half Year",
  hallo: "Hallo",
  halloId: "Hallo Id",
  halloUser: "Hallo User",
  has: "Has",
  have: "Have",
  haveNo: "No",
  height: "Height",
  help: "Help",
  helpManual: "Help Manual",
  hiUser: "Hello! %s",
  home: "Home",
  hour: "hrs",
  hourly: "Hourly",
  i: "I",
  iAm: "I am",
  id: "Id",
  idCode: "Code",
  if: "If",
  iKnow: "Yes, I know",
  image: "Image",
  numberOfImages: "%s Images",
  imageArchive: "Image Archive",
  imageCategory: "Image Categories",
  imagingDate: "Imaging Date",
  implementedDuring: "Implemented During",
  implementedBy: "Implemented By",
  initials: "Initials",
  inRegardTo: "In Regard To",
  insert: "Insert",
  inService: "In Service",
  inTo: "into",
  invalid: "Is Not Valid",
  invalidEmail: "Invalid Email",
  invalidMobileNo: "Mobile No. is a 10-digit number starting with 0",
  invalidSSN: "SSN number is invalid",
  invalidUsername: "Username must be 4-12 letters or digits",
  invalidPassword: "Password should be 6 letters/digits or more",
  passwordNotTheSame: "Password is not the same",
  irrigationArea: "Irrigation Area",
  is: "Is",
  isNot: "Is Not",
  jobConclusion: "Conclusion",
  jobCompletedOn: "Date and Time of Completion",
  jobName: "Job Name",
  openJobPosition: "(Open)",
  khun: 'Khun',
  ka: "",
  krub: "",
  kilometer: "KM",
  landData: "Land Data",
  landUploader1: "Supported fiels are gpx file and shape file",
  landUploader2: "A shape file includes *.shp, *.dbf, *.prj and *.cpg files that must be put together in a *.zip file",
  landUploader3: "Projection is WGS84 or as defined in the *.prj file",
  landUploader4: "Text encoding is UTF-8 or as defined in the *.cpg file",
  landUploader5: "Complex and Multi* Geometry are not supported",
  landUploader6: "Must contain attributes as defined. Click her to",
  landUploader7: "Download Template",
  landUploaderSupportedFiles: "Supported fiels are gpx file and shape file. A shape file includes *.shp, *.dbf, *.prj and *.cpg files that must be put together in a *.zip file",
  language: "Language",
  lastNDays: "Last %s Days",
  lastOneMonth: "Last 1 Month",
  lastNMonths: "Last %s Months",
  lastOneYear: "Last 1 Year",
  lastNYears: "Last %s Year%s",
  latestUpdate: "Updated on %s",
  latitude: "Latitude",
  latNorth: "N",
  latSourth: "S",
  layer: "Layer",
  layers: "Layers",
  legend: "Legend",
  lte: "LTE.",
  gte: "GTE.",
  between: "Between",
  livingCountry: "Living Country",
  locatedIn: "Located in",
  locatePin: "Locate Pin",
  location: "Location",
  logAction: "Action",
  login: "Login",
  logining: "L  O  G  I  N",
  loginWasNotSuccessful: "Login Was Not Successful",
  logout: "Logout",
  lonEast: "E",
  longitude: "Longitude",
  lonWest: "W",
  male: "Male",
  manage: "Manage",
  me: "Me",
  measure: "Measure",
  messageTypeFile: "File",
  messageTypeHtml: "Link",
  messageTypeImage: "Image",
  messageTypeLocation: "Location",
  messageTypeSticker: "Sticker",
  messageTypeVideo: "Video",

  menuFile: "File",
  menuFileNew: "New File",
  menuFileLocal: "Open Local",
  menuFileServer: "Open from Server",
  menuFileSave: "Save File",
  menuFileUpload: "Upload File",
  menuFileShare: "Share ...",
  menuFileDeleteFromServer: "Delete Uploaded File",
  menuFileProperties: "Properties",
  menuFilePrint: "Print ...",
  menuFileSaveAsFile: "Capture Screen",
  menuFileSaveAsPdf: "Save As PDF",
  menuFileSaveAsPng: "Save As PNG",
  
  menuData: "Data",
  menuDataLocal: "Add Local Data",
  menuDataServer: "Add Data from Server",
  menuDataManage: "Calculate Data",
  menuDataExport: "Export Data",
  menuDataExportZip: "Export to Zip File",
  menuDataExportExcel: "Export to Excel",
  menuDataFilter: "Filter Data",

  menuChart: "Chart",
  menuChartTable: "Table",
  menuChartPivot: "Pivot Table",
  menuChartTableSum: "Summary Table",
  menuChartBars: "Bar Chart",
  menuChartLines: "Line Chart",
  menuChartAreas: "Area Chart",
  menuChartPie: "Pie Chart",
  menuChartDonut: "Donut Chart",
  menuChartGauge: "Gauge Meter",
  menuChartComposite: "Composite",
  menuChartScatter: "Scatter Plot",
  menuChartBoxPlot: "Box Plot",
  menuChartPallel: "Parallel Lines",
  menuChartTreemap: "Treemap",
  menuChartMap: "Map",

  meter: "M",
  member: "Member",
  mine: "mine",
  minute: "min",
  miss: "Miss",
  mr: "Mr.",
  mrs: "Mrs.",
  mobile: "Mobile",
  mobileNo: "Mobile No.",
  month: "Month",
  months: "Month%s",
  monthsText: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],
  more: "More...",
  moreThan: "More than",
  multipleSelected: "Multiple Items Selected",
  music: "Music",
  my: "My",
  nDaysAgo: "%s Days Ago",
  nMonthsAgo: "%s Months Ago",
  nYearsAgo: "%s Years Ago",
  oneDayAgo: "1 Day Ago",
  oneMonthAgo: "1 Month Ago",
  oneYearAgo: "1 Year Ago",
  name: "Name",
  namePrefix: "Prefix",
  nationalId: "National ID",
  nationality: "Nationality",
  nearTo: "Near to",
  new: "New",
  news: "News",
  newUser: "New User",
  newJobPosition: "New Position",
  newRequest: "Submit Form",
  next: "Next",
  nickname: "Nickname",
  night: "At Night",
  no: "NO",
  noData: "No Data",
  noImage: "No Image",
  noEmailBounded: "No Email Bounded",
  noMobileBounded: "No Mobile Bounded",
  noneSelected: "None Selected",
  not: "Not",
  notRegistered: "Not Registered",
  notSpecify: "Not Specify",
  notYet: "Not",
  notification: "Notification",
  notSet: "Not Set",
  notSupportedFile: "Not support these types of file: ",
  number: "Number",
  of: "of",
  ofAbove: "",
  ofBounded: "",
  officialAccount: "Official Account",
  ofPresent: "",
  ofMine: "",
  ofNew: "", 
  ofWithin: "",
  ofYours: "",
  ok: "OK",
  onlineUsers: "Online Users",
  oneMonth: "1 Month",
  open: "Open",
  or: "or",
  organization: "Organization",
  organizationName: "Organization Name",
  organizationNameIsRequired: "Required organization name, as well as sub-district if address is specified",
  otpCode: "OTP Code",
  others: "Others",
  outFrom: "out from",
  ownerName: "Pakkret Municipality",
  ownerName0: "Engineering Office",
  ownerName1: "Nonthaburi Province",
  ownerAddress: "1, Moo 5, Chaengwattana Road, Pakkret Sub-District, Pakkret District, Nonthaburi Province, 11120 Tel: (+66) 0-2960-9704~14",

  passportNo: "Passport No.",
  password: "Password",
  permission: "Permission",
  personality: "Personality",
  personInCharge: "Person in Charge",
  phoneCall: "Phone Call",
  photo: "Photo",
  place: "Place",
  please: "Please",
  preferTo: "I prefer to",
  preferTH: "",
  present: "Present",
  privacy: "Privacy",
  privacyPolicy: "Privacy Policy",
  private: "PRIVATE",
  privilege: "Use Privilege",
  policy: "Policy",
  profile: "My Profile",
  province: "Province",
  provinceName: "Province Name",
  public: "PUBLIC",
  publish: "Publish",
  QRCode: "QR Code",
  query: "Query",
  quickGuide: "Quick Guide",
  read: "Read",
  remove: "Remove",
  reason: "Reason",
  refuse: "Refuse",
  refuseReason: "Refuse Reason",
  refuseNotInArea: "Not in Responsible Area",
  refuseNotPublicProperty: "Not Public Property",
  refuseNotAbleToContactRequester: "Not Able to Contact the Requester",
  region: "Region",
  register: "Register",
  registerOrganizations: "Register Organizations",
  registerUsers: "Register Users",
  registerAnotherUser: "Register Another User?",
  registration: "Registration",
  reloadMap: "Reload Map",
  request: "Request",
  requests: "Requests",
  requester: "Requester",
  requesterInfo: "Requester Info",
  requestAddComment: "Add Comment",
  requestReadAllComments: "Read All Comments",
  requestRecentComments: "Recent Comments",
  requestServiceLocation: "Service Location",

  requestStatus: "Request Status",
  requestStatusDraft: "Draft",
  requestStatusSent: "Sent",
  requestStatusNew: "New",
  requestStatusReturned: "Returned",
  requestStatusRefused: "Refused",
  requestStatusAccepted: "Accepted",
  requestStatusAssigned : "Assigned",
  requestStatusPreparing: "Preparing",
  requestStatusImplementing: "Implementing",
  requestStatusDone: "Done",
  requestStatusClosed: "Closed",

  requestTotal: "Total Request",
  requestNew: "New Request",
  requestOverDue: "Overdue",
  requestImplementing: "Implementing",
  requestCompleted: "Completed",

  requestTableTitleNew: "New Requests",
  requestTableTitleOverDue: "Overdue Requests",
  requestTableTitleImplementing: "Requests that are being implemented",
  requestTableTitleCompleted: "Completed Requests",
  requestTableTitleReceivedInOneMonth: "Requests Received In 1 Month",

  requestConstruction: "Construction",
  requestUrbanPlanning: "Urban Planning",
  requestCivilWorks: "Civil Works",
  requestSanitary: "Sanitary",
  required: "Required",
  resendLink: "Resent Link",
  responsibleArea: "Responsible Area",
  responsibleAreaProvince: "Responsible Province",
  responsibleAreaCounty: "Responsible County",
  responsibleAreaTown: "Responsible Town",
  return: "Return",
  returnForEdit: "Return for correction",
  returnForEditInstruction: "Instructions",
  revoke: "Revoke",
  revoked: "Revoked",

  rAskForService: "Ask For Service",
  rReport: "Report",
  rMakeComplaint: "Make Complaint",
  rGiveOpinion: "Give Opinion",

  reset: "Reset",
  result: "Work Result",
  retrieve: "Retrieve",
  ridOffice: "RID Office",
  ridProject: "RID Project",
  save: "SAVE",
  saveAsExcelFile: "Save As *.xlsx",
  saveDataToDatabase: "Save Data to Database",
  scanFriendQRCode: "SCAN FRIEND's QR CODE",
  scanMe: "SCAN QR CODE TO ADD ME TO YOUR HALLO",
  scanQRCode: "SCAN QR CODE",
  schedule: "Schedule",
  search: "Search",
  select: "Select",
  selectAll: "Select All",
  selectMeasures: "Select Measures",
  selectObservedTimeRange: "Select Observed Time Range",
  selectAGpxOrZipFile: "Select a %s or %s file",
  selectArea: "Select Area",
  send: "Send",
  sender: "Sender",
  sendingEmail: "Sending email to you. Please wait a minute...",
  sent: "Sent",
  service: "Services",
  serviceCategory: "Services Category",
  sentViaEmail: "Sent via Email",
  set: "Set",
  seted: "Set",
  settings: "Settings",
  share: "Share",
  show: "Show",
  showOnMap: "Shown on Map",
  shoreLine: "Shoreline",
  since: "Since",
  size: "Size",
  sms: "SMS",
  specify: "Specify",
  startDate: "Start Date",
  stationAndData: "Station & Data %s",
  stationOverview: "Overview",
  street: "Street",
  submit: "Submit",
  supervisor: "Supervisor",
  surname: "Surname",
  takeNewPhoto: "Take New Photo",
  team: "Team",
  termsAndConditions: "Terms & Conditions",
  test: "Test",
  thai: "Thai",
  then: "then",
  thungkula: "Thung Kula Ronghai",
  till: "To",
  timeAm: "AM",
  timePm: "PM",
  to: "to",
  toTo: "to",
  toClick: "To click",
  today: "Today",
  toSpecify: "To Specify",
  toSet: "To Set",
  town: "Sub-district",
  townName: "Sub-district Name",
  toYou: "",

  unit: "Unit",
  unitM: "M",
  unitM2: "M<sup>2</sup>",
  unitSQM: "SQ.M",
  unitKM: "KM",
  unitKM2: "KM<sup>2</sup>",
  unitSQKM: "SQ.KM",
  unitMetric: "Metric",
  unitThai: "Thai",
  unitRai: "Rai",
  unitNgan: "Ngan",
  unitWah: "Sq.Wah",

  until: "Until",
  update: "Update",
  updated: "Updated",
  upload: "Upload",
  usage: "Use",
  usageCounter: "Page Counter: %s",
  use: "Use",
  user: "User",
  users: "Users",
  userId: "User Id",
  userName: "User Name",
  userLog: "User Logs",
  userPrivilege: "User Privilege",
  userProfile: "User Profile",
  verify: "Verify",
  via: "via",
  viaZH: "",
  video: "Video",
  videoCall: "Video Call",
  voice: "Voice",
  valid: "Valid",
  vsLastMonth: "VS Last Month",
  waiting: "Please wait a moment...",
  waterResource: "Water Resource",
  waterDischargeArea: "Discharge Area",
  watershed: "Drainage Basin",
  waterUseLayer: "Present Water Demand",
  week: "Week",
  weekDaysText: ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],
  welcome: "Welcome",
  welcomeUser: "Welcome! %s",
  width: "Width",
  within: "Within",
  wouldLikeTo: "Would Like To",
  year: "Year",
  years: "Year%s",
  yearText: "Year",
  yes: "YES",
  yesterday: "Yesterday",
  you: "You",
  your: "your",
  zipCode: "Zip Code",

  resetMapRotation: "Reset Rotation",
  searchLocationOnMap: 'Search Location',
  panMapLeft: "Pan Left",
  panMapRight: "Pan Right",
  panMapUp: "Pan Up",
  panMapDown: "Pan Down",
  fullMapExtent: "Full Extent",
  zoomIn: "Zoom In",
  zoomOut: "Zoom Out",
  queryMapInfo: "Query Map",
  measureDistance: "Measure Distance",
  measureArea: "Measure Area",
  measureCoordinate: "Measure Coordinate",
  printMap: "Print Map",
  changeBasemap: "Change Basemap",

  map: "Map",
  mapBase: "Base Map",
  mapBases: "Base Maps",

  binding: "Binding",
  bing: "Bing",
  bingAerial: "Aerial",
  bingAerialWithLabels: "Aerial with Label",
  bingRoad: "Road",

  gistda: "GISTDA",
  gistdaGO: "Thaichote",

  google: "Google",
  googleHybrid: "Hybrid",
  googleRoad: "Street Map",
  googleSatellite: "Satellite",
  googleTerrain: "Terrain",

  osm: "OSM",
  osmCycleMap: "CycleMap",
  osmMapnik: "Mapnik",
  osmOffline: "Offline",
  osmTransportMap: "Transport",

  userGroup: "UserGroup",
  userRegistration: "User Registration",

  sAboutAlert: "Specify preference to be notified by sound or vibration when receiving new message",
  sAboutAllowFindMyRequests: "All public requests or only those submitted within the specified days can be found. Private requests will never be seen by friends",
  sAboutBinding: "When bound, you can login using mobile number, or with Facebook, Twitter and Google account",
  sAboutBindingMobile: "When bound, you will utilize the two-factor authentication service, which enable your account and login to be more secure",
  sAboutCatchword: "A good catchword helps display your personality and increases your attraction to others",
  sAboutClearHalloChannels: "All invidual and group chat channels will be cleared",
  sAboutEmail: "With email bounded, if you forgot your password, you can request the system to help reset it. Besides, you are able to receive important news that could help you use our services more efficiently",
  sAboutEmailConfirmation: "After click at \"Submit\",we will send a confirmation link to your email as entered. Please follow the email instructions to complete the rest steps",
  sAboutEnableNightMode: "Set whether or not the sound alert and vibration will be enabled at night time",
  sAboutHalloId: "sAboutHalloId",
  sAboutLogout: "After logout, you can continue to search and read news, but will no longer be able to submit request and chat with friends",
  sAboutPassword: "A password should have at least 6 letters in that at least one should be digit, lowercase and uppercase letter",
  sAboutShowPreviousText: "When enabled, message notification will show its sender name and summary on the screen",
  sAboutUserId: "A user ID consists of 4 to 12 digits or letters that are case sensitive",
  sAboutUserName: "Please specify your given name and family name. Your name is used to refer to you in the requests that you submitted",
  sAboutUserNickname: "Nick name is used for display in the contact list and chat. You can use any name you like to show off your personality",
  sAcceptThisRequest: "Please confirm if you want to accept this request",
  sAreYouGoingToDeleteSelectedFeatures: "Are You Going to Delete Selected Features?",
  sAreYouGoingToDeleteThisItem: "Are You Going to Delete This Item?",
  sAreYouGoingToGrantUserAccount: "Are You Going to Grant Access to %s?",
  sAreYouGoingToRevokeUserAccount: "Are You Going to Revoke Access from %s?",
  sAtLeast3PointsAreRequired: "At least 3 points are required!",
  sActivateAccount: "Activate Account",
  sActivateAccountSuccessful: "You have successfully activated your account. You can start to use the system by clicking the [Start to Use] button as shown below. Enjoy!",
  sStartToUse: "Start to Use",

  sButRememberYourHalloId: "But you remember your HalloId",
  sCancelDraftRequest: "Your have not submitted this request. If you cancel it, it will be lost immediately",
  sCancelRequestEdit: "You have edited this request. If you cancel it, all changed will be lost immediately",
  sChangeAccountItIsNotMine: "Change account. Above is not mine",
  sChangeEmailSuccessful: "You have successfully changed your email. Your new email is %s",
  sClickMapToMeasure: "Click map to measure",
  sConfirmationCodeNotReceiveYet: "Not receive confirmation code, tap here",
  sConfirmationCodeSentToSMS: "The OTP code has been sent to your mobile via SMS",
  sConfirmationLinkNotReceiveYet: "Not receive confirmation link, tap here",
  sConfirmationLinkSentToEmail: "The confirmation link has been sent to your email. Please follow the instructions to continue",
  sConfirmationEamilRequired: "A confirmation link was once sent to your email. Please check your mail box and follow it to complete your registration",
  sCanSelectMax7Days: "You can select max range of 7 days",
  sDeleteParagraph: "Really want to delete this paragraph?",
  sEmailConnectsYouAtAnyPlace: "One email connects you at any place, any time",
  sEmailResent: "Email resent",
  sEmailVerified: "Email verified. You can login now",
  sEmailVerificationLinkInvalid: "Email confirmation is invalid. Enter your email below and click the button [Resent Confirmation Email] to try it again",
  sEnterPresentPassword: "Present Password",
  sEnterSignedUpEmail: "Enter the email you used to sign up",

  sErrorConnection: "There appears to be a problem with your internet connection",
  sErrorUnknown: "We received an unexpected status code from the server",

  sForgotPassword: "Oh! I forgot my password. What to do?",
  sForgotPasswordSent: "You have successfully requested a new random password. We have sent it to your email. Thanks!",
  
  sForLoginAndContact: "For Login and Contact via System",
  sForUserPermissionAndWorkFlowManagement: "For Permission and Work Management",

  sGeneralAutoSavePhoto: "Auto Save Photo",
  sGeneralAutoSaveVideo: "Auto Save Video",
  sGeneralClearChatHistory:"Clear Chat History",
  sGeneralStorage: "Storage",
  sGeneralTextSize: "Text Size",
  sGeneralTurnOffSpeaker: "Turn off Speaker",

  sInvalidPassword: "Password is invalid",
  sJustAVisitor: "Skip Login? Tap here",
  sLoginInvalidAccount: "Login infomation is not correct",
  sLoginWithFollowingAccount: "You can also login with following accounts",
  sLogout: "Do you really want to log out?",
  sMeansYouAgree: "means you have agreed with the",
  sNewMessages: "New Messages",
  sMustSelectAtLeastOnePhoto: "You must select at least one photo",
  sMustSelectAtLeastOneVideo: "You must select at least one video",
  sMustSelectOneCategory: "Must select one category",
  sMustSpecifyAllFieldsMarkedWithStar: "Enter data in all fields marked with star (*)",
  sMustSpecifyEmailAndOrMobileNo: "Must specify either email or mobile number, or both is better",
  sNoDataFound: "No Data Found",
  sNoDataSelected: "No Data Selected",
  sNoPhotoAvailable: "No photo exists in album",
  sNotAllowedToDeleteLandWithFarmerSSN: "It is not allowed to delete a land having farmer registered",
  sNotAllowedToDeleteLandDueTo: "It is not allowed to delete a land located outside responsible area",

  sNotificationEnableAlertSound: "Enable Alert Sound",
  sNotificationEnableNightMode: "Enable Night Mode",
  sNotificationEnableVibrate: "Enable Vibrate",
  sNotificationMessage: "Message",
  sNotificationVideoCall: "Video Call",
  sNotificationShowPreviewText: "Show Preview Text",

  sNumberOnly: "Number Only",
  sNumberOfPhotoSelected: "Photo selected",
  sOpenPasswordResetLinkInEmail: "Please open your email and follow the instructions to reset your password",
  sPasswordNotTheSame: "Password confirmation is wrong. Please correct it",
  sPasswordReset: "You have reset your password",
  sPasswordResetLinkSentToEmail: "Password reset link has been sent to your email",
  sPasswordResetLinkSentToEmailFailed: "Retrieval password encountered following error",
  sPasswordResetLinkSentToEmailFailedInstruction: "Please correct the error and try it again",

  sPrivacyAllowAddMeByContactCard: "Allow Add Me by Contact Card",
  sPrivacyAllowAddMeByGroupChat: "Allow Add Me by Group Chat",
  sPrivacyAllowAddMeByQRCode: "Allow Add Me by QR Code",
  sPrivacyAllowFindMeByEmail: "Allow Find Me by Email",
  sPrivacyAllowFindMeByHalloId: "Allow Find Me by HalloId",
  sPrivacyAllowFindMeByPhone: "Allow Find Me by Phone",
  sPrivacyAllowFindMyRequests: "Allow Find My Requests",
  sPrivacyInvitationRequireConfirmation: "Invitation Require Confirmation",

  sRegisterUser: "No account? Let me register one first",
  sRegistrationLastStepCancel: "You are almost to complete the registration. If you cancel it, you need to do it all again",
  sRegistrationName: "Now enter your names. Optionally, click at the photo icon to select your Avatar",
  sRequestTitleUndefined: "Request title is undefined",
  sRequestToAccessAlbum: "Hallo wants to read your album in order to show photos for selection",
  sResentConfirmationSMS: "Re-send Confirmation Code",
  sResentConfirmationEmail: "Re-send Confirmation Email",
  sResetPasswordViaBoundedEmail: "Reset Password via Bounded Email",
  sResetPasswordViaBoundedMobile: "Reset Password via Bounded Mobile",
  sResetPasswordViaAnotherEmail: "Reset Password via Another Email",
  sResetPasswordViaAnotherMobile: "Reset Password via Another Mobile",
  sSameEmailAsPresentOne: "This email is the same as your present one",
  sScanQRCode: "Use the volume buttons to turn the flash on or off",
  sSelectPhotoFromAlbum: "Select Photo From Album",
  sSelectGetInfoToolAndClickonMapToQuery: "Select GetInfo tool and click on map to query",
  sShare: "Select an application to share",
  sTakeNewPhoto: "Take New Photo",
  sTapToAddText: "Tap to add text",
  sToChangePassword: "For better security management, please enter your present password",
  sUserLastLogin: "Well, I want to user last login",
  sWelcomeToHallo: "Welcome to Hallo!. Now you can start to use it. Strongly recommend to set your password as the first thing to do",
  sWelcomeToJoin: "Welcome to join us",
  sWhatsUp: "Tap to set your catchword",
  sWillSendEmailTitle: "Email Confirmation",
  sWillSendEmail: "We will send a confirmation link to your email at following address",
  sWillSendSMSTitle: "Mobile Number Confirmation",
  sWillSendSMS: "We will send a One-Time-Password (OTP) code via SMS to your mobile at following number",
  sWrongPassword: "Password is not correct. Please try it again. If you forgot your password, logout then on the login page, you can request new password",
  sCanLoginUsingIdEmailMobileNo: "Can login using National ID, Email or Mobile No.",

  //GISagro4.0
  mapping: "Mapping",
  measuring: "Measuring",
  modeling: "Modelling",
  monitoring: "Monitoring",
  managing: "Managing",
  undo: "Undo",
  redo: "Redo",
  linkData: "Link Data",
  uploadCropData: "Upload %s Data",
  uploadGPX: "Upload File *.gpx|*.shp",
  addPointXY: "Add Point X,Y",
  addPoint: "Add Point",
  addPointAzimuthDistance: "Add Point Azimuth, Distance",
  addPointBearingDistance: "Add Point Bearing, Distance",
  addPointDxDy: "Add Point Dx,Dy",
  addPointA2BDistance: "Add Point A to B",
  dragPoint: "Move Point",
  deletePoint: "Delete Point",
  deletePoints: "Delete Points",
  addPolygonXY: "Add Polygon X,Y",
  addPolygon: "Add Polygon",
  addPolygonTrace: "Add Polygon from Points",
  cutPolygon: "Cut Polygon",
  splitPolygon: "Split Polygon",
  scalePolygonArea: "Scale Polygon",
  transformPolygon: "Transform Polygon",
  modifyPolygon: "Modify Polygon",
  dragPolygon: "Move Polygon",
  indian75ToWgs84: "Transform Indian to WGS84",
  deletePolygon: "Delete Polygon",

  netSpeed: "Net Speed",
  adminArea: "Admin Area",
  dataSource: "Source",
  cropType: "Crop Type",
  cropFamilies: "Crop Family",
  cropTypes: "Crop Type",
  cropSpecies: "Crop Species",
  deedType: "Deed Type",
  grow: "Grow",
  harvest: "Harvest",
  growOrHarvestYear: "Grow/Harvest Year",
  selectYear: "Select a Year",
  searchResult: "Search Result",

  rice: "Rice",
  maize: "Maize",
  sugarcane: "Sugarcane",
  cassava: "Cassava",
  
  mlLandMonument: "Land Monument",
  mlFromAllSystems: "Layer from DOAE System",
  mlFarmland: 'GISagro Farmland',
  mlFarmlandRIPBY: "Linked at Present Year", //"วาดปีงบประมาณ %s",
  mlFarmlandRIBY: "Linked in %s",
  mlFarmlandRBBY: "Linked before %s",
  mlFarmlandR: "Registered",
  mlFarmlandNR: "Not Registered",

  gBaseMapImagery: "Base Map/Imagery",
  layerGoogleStreetMap: "Google Street Map",
  layerGoogleHybridMap: "Google Hybrid Map",
  layerSatelliteImageryMunisan: "Satellite Imagery-Munisan"
};